import {
	CapacityName,
	CapacityUnit,
	FilterGroup,
	vesselMetadataTypeParser,
} from "@pages/DatabasePage/plantMetadata/PlantMetadata"
import { common } from "@utils/common"
import { CustomerData } from "api"

export type MapTableVesselData = {
	vessel: string
	type: string
	capacity?: {
		name: CapacityName
		value: number
		unit: CapacityUnit
	}
	charterer: string
	filterGroup?: FilterGroup
}

export const getHardCodedVesselData = (
	currentCompany: string | undefined
): MapTableVesselData[] => {
	const plants: CustomerData["plants"] =
		currentCompany !== undefined
			? (common.companyDataFromCompanyName.get(currentCompany)?.plants ?? {})
			: {}

	return Object.entries(plants).map(([name, data]) => {
		const type = data.vesselType ?? "Unknown"

		try {
			const metaData = vesselMetadataTypeParser.parse(data.metaData)
			const capacityName = metaData["CapacityName"]
			const capacityUnit = metaData["CapacityUnit"]
			const capacityValue =
				capacityName === "Deadweight"
					? data.deadWeightTonnes
					: capacityName === "Gross tonnage"
						? data.grossTonnage
						: capacityName === "Bollard pull"
							? data.bollardPullTonnes
							: capacityName === "Cargo hold"
								? data.cargoHoldM3
								: undefined
			return {
				vessel: name,
				type,
				capacity:
					[capacityName, capacityValue, capacityUnit].includes(undefined) ||
					[capacityName, capacityValue, capacityUnit].includes(null)
						? undefined
						: {
								name: capacityName ?? "Deadweight",
								unit: capacityUnit ?? "",
								value: capacityValue ?? 0,
							},
				charterer: metaData["Charterer"] ?? "--",
				filterGroup: metaData["Filter group"],
			}
		} catch (error) {
			return {
				vessel: name,
				type,
				charterer: "--",
				filterGroup: undefined,
			}
		}
	})
}
